import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const PilotIntro = () => (
    <section
        data-testid="pilot-intro"
        className="relative border-y border-white/10 bg-surface/40"
    >
        <div className="mx-auto grid max-w-[1600px] gap-8 px-6 py-14 md:px-10 lg:grid-cols-12 lg:items-center lg:px-16 lg:py-16">
            <motion.p
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist lg:col-span-3"
            >
                <span className="h-1.5 w-1.5 bg-accent" />
                THE PILOT
            </motion.p>
            <motion.p
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="pilot-intro-copy"
                className="max-w-2xl text-[16px] leading-relaxed text-white/90 lg:col-span-9"
            >
                The pilot gives selected homeowners an opportunity to use
                BuildEase with their real residential construction plans and
                provide feedback before wider public launch.
            </motion.p>
        </div>
    </section>
);

export default PilotIntro;
